<template>
  <div class="bb-cropper" @click.stop>
    <div class="bb-cropper-container">
      <div class="bb-cropper-container__active" v-if="!cropImg">
        <vue-cropper
          v-if="imgSrc"
          :viewMode="3"
          :cropBoxMovable="false"
          :cropBoxResizable="false"
          :toggleDragModeOnDblclick="false"
          :minContainerHeight="400"
          :minContainerWidth="400"
          :aspectRatio="1"
          :autoCropArea="1"
          dragMode="move"
          ref="cropper"
          :src="imgSrc"
          alt="Source Image">
        </vue-cropper>
      </div>
      <div class="bb-cropper-container-preview" v-else>
        <img
          class="bb-cropper-container-preview__img"
          :src="cropImg"
          alt="Cropped Image"
        />
      </div>
    </div>
    <button class="bb-cropper__button bb-button" @click.stop="cropImage">SAVE</button>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'

export default {
  name: 'UploadImage',
  components: {VueCropper},
  props: ['file'],
  data () {
    return {
      cropImg: false,
      itemPreviewImage: false,
      imgSrc: false,
      fileData: new FormData()
    }
  },
  methods: {
    createImage (file) {
      const reader = new FileReader()
      reader.onload = evt => {
        this.imgSrc = evt.target.result
      }
      reader.readAsDataURL(file)
    },
    cropImage () {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      const fileData = new FormData()
      const file = this.dataURLtoFile(this.cropImg, this.file.name)
      fileData.set('file', file)
      this.$emit('uploadFile', fileData, this.cropImg)
    },
    dataURLtoFile (data, filename) {
      const arr = data.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    }
  },
  watch: {
    file () {
      this.cropImg = false
      this.createImage(this.file)
    }
  },
  beforeMount () {
    this.cropImg = false
    this.createImage(this.file)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-cropper {
    &-container {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 400px;
      height: 400px;
      border-radius: 6px;

      &-preview {
        height: 100%;
        width: 100%;

        &__img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    &__button {
      margin-top: 30px;
      width: 400px;
      height: 42px;
    }
  }

</style>

<style lang="scss">
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-cropper {
    .cropper-view-box,
    .cropper-face {
      border-radius: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/UploadImage/UploadImage.vue